import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Redirect } from 'react-router-dom'

import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip
} from '@material-ui/core';
import { dateService, MyPATLink } from '../../common';

const styles = (theme: Theme) => createStyles({
  cursorPointer: {
    cursor: 'pointer',
  },
  mr1x: {
    marginRight: theme.spacing.unit,
  },
  mb1x: {
    marginBottom: theme.spacing.unit,
  },
  cardContentRoot: {
    position: 'relative',
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    '&:last-child': {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  textCapitalize: {
    textTransform: 'capitalize',
  },
  textEllipsis: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: theme.spacing.unit
  },

  contentType: {
    fontSize: theme.spacing.unit * 1.5,
    padding: '4px 0px',
    height: 'auto',
  },

  title: {
    lineHeight: theme.spacing.unit * 4 + "px",
  },
  subTitle: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      ...theme.typography.body1,
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& img': {
      display: 'inline-block',
      marginRight: theme.spacing.unit * 1.5,
      flex: 0,
    }
  },



  statusSection: {
    '& .updatedBy': {
      fontSize: '14px',
      '& span': {
        textTransform: 'capitalize',
      }
    }
  },
  statusDraft: {
    '& .createdBy': {
      fontSize: '14px',
      '& span': {
        textTransform: 'capitalize',
      }
    }
  },
  progressSection: {
    marginBottom: theme.spacing.unit / 2,
  },
  progressBar: {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    width: theme.spacing.unit * 10,
    marginRight: theme.spacing.unit * 2,
    '& > span': {
      display: 'inline-block',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: '100%',
      height: theme.spacing.unit * 2,
      borderRadius: theme.spacing.unit * 4,
      backgroundColor: theme.palette.grey[300],
      zIndex: 0,
      '&.progress': {
        zIndex: 1,
        backgroundColor: theme.palette.secondary.main,
      }
    }
  },

  statusBtn: {
    color: theme.palette.common.white,
    padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit * 2.5}px`,
    display: 'inline-block',
    fontSize: '14px',
    marginRight: theme.spacing.unit,
    borderRadius: '1em',
    verticalAlign: 'middle',
    lineHeight: 1.25,
    backgroundColor: theme.palette.grey[400],
  },
  publishedBtn: {
    backgroundColor: theme.palette.primary.main,
  },
  inReviewButton: {
    background: '#B3B4B3',
  },
  liveButton: {
    background: '#8ECE30',
  },
  plannedButton: {
    background: '#FF830F',
  },
});

interface ContentCardProps extends WithStyles<typeof styles> {
  history: any,
  cardInfo: any,
  contentType: any,
  contentSubtype: any,
}

const ContentCard = (props: ContentCardProps) => {
  const { classes, cardInfo, history } = props;

  const contentTypeIcon: any = {
    "question": "/assets/img/mylibrary/content-type/question.png",
    "studymaterial": "/assets/img/mylibrary/content-type/notes.png",
    "formulas": "/assets/img/mylibrary/content-type/maths.png",
    "videos": "/assets/img/mylibrary/content-type/play.png",
    "audios": "/assets/img/mylibrary/content-type/play.png",
    "testpapers": "/assets/img/mylibrary/content-type/test.png"
  }

  const getCodeName = (code: string, subcode: string) => {
    if (props.contentSubtype[subcode]) {
      return props.contentSubtype[subcode];
    }
    if (props.contentType[code]) {
      return props.contentType[code];
    }
  };

  const redirectUrl = (id: any, e: any) => {
    let url = "content/preview/" + id;
    history.push(url);
  }

  const getSubjectData = () => {
    let subjectString: string = ' ';
    const subject: string = _.get(cardInfo, 'subjects[0].subjectId.name', '');
    const chapter: string = _.get(cardInfo, 'subjects[0].chapters[0].chapterId.name', '');
    if (!_.isEmpty(subject)) {
      subjectString += ` > ${subject}`;
    }
    if (!_.isEmpty(chapter)) {
      subjectString += ` > ${chapter}`;
    }
    return subjectString;
  }

  const formatPercentage = (val: any) => val && !isNaN(val) ? parseInt(val) : "0";

  const getContentStatus = () => {
    let contentStatus: any;
    if(!cardInfo.aclMetaData.updatedBy.fullName && cardInfo.aclMetaData.updatedBy.email){
      cardInfo.aclMetaData.updatedBy["fullName"] = cardInfo.aclMetaData.updatedBy.email.split('.')[0];
      cardInfo.aclMetaData.updatedBy["fullName"] = cardInfo.aclMetaData.updatedBy["fullName"].split('@')[0];
    }
    if(!cardInfo.aclMetaData.createdBy.fullName && cardInfo.aclMetaData.createdBy.email){
      cardInfo.aclMetaData.createdBy["fullName"] = cardInfo.aclMetaData.createdBy.email.split('.')[0];
      cardInfo.aclMetaData.createdBy["fullName"] = cardInfo.aclMetaData.createdBy["fullName"].split('@')[0];
    }
    if (cardInfo.status == 'DRAFT') {
      contentStatus = (
        <div className={classes.statusDraft}>
          <div className={classes.progressSection}>
            <div className={classes.progressBar}>
              <span className='progress' style={{ width: `${cardInfo.completionPercent}%` }}></span>
              <span></span>
            </div>
            <Typography variant="caption" inline>{`${formatPercentage(cardInfo.completionPercent)}%  Draft`}</Typography>
          </div>
          <Typography variant="caption" className='createdBy'>
            Created By <span>{_.get(cardInfo, 'aclMetaData.createdBy.fullName', "")}</span>
          </Typography>
        </div>
      )
    } else if (cardInfo.status == 'PUBLISHED') {
      contentStatus = (
        <div className={classes.statusSection}>
          <div className={classes.progressSection}>
            <Typography variant="caption" inline className={cx(classes.statusBtn, classes.publishedBtn)}>Published</Typography>
            <Typography variant="caption" inline>{dateService.timeSince(cardInfo.updatedAt)}</Typography>
          </div>
          <Typography variant="caption" className='updatedBy'>
            By <span>{_.get(cardInfo, 'aclMetaData.updatedBy.fullName', "")}</span>
          </Typography>
        </div>
      )
    } else if (cardInfo.status == 'REVIEW') {
      contentStatus = (
        <div className={classes.statusSection}>
          <div className={classes.progressSection}>
            <Typography variant="caption" inline className={cx(classes.statusBtn, classes.inReviewButton)}>In Review</Typography>
            <Typography variant="caption" inline>{dateService.timeSince(cardInfo.updatedAt)}</Typography>
          </div>
          <Typography variant="caption" className='updatedBy'>
            By <span>{_.get(cardInfo, 'contentReviewer.fullName', "")}</span>
          </Typography>
        </div>
      )
    } else if (cardInfo.status == 'LIVE') {
      contentStatus = (
        <div className={classes.statusSection}>
          <div className={classes.progressSection}>
            <Typography variant="caption" inline className={cx(classes.statusBtn, classes.liveButton)}>Live</Typography>
          </div>
        </div>
      )
    } else if (cardInfo.status == 'PLANNED') {
      contentStatus = (
        <div className={classes.statusSection}>
          <div className={classes.progressSection}>
            <Typography variant="caption" inline className={cx(classes.statusBtn, classes.plannedButton)}>Planned</Typography>
            <Typography variant="caption" inline>{dateService.timeSince(cardInfo.updatedAt)}</Typography>
          </div>
        </div>
      )
    }
    return contentStatus;
  }



  return (
    <Card onClick={(e) => { redirectUrl(cardInfo._id, e) }} className={classes.cursorPointer} >
      <CardContent className={classes.cardContentRoot}>
        <Grid container alignItems="center">
          <Grid item xs={12} className={classes.mb1x}>
            <Grid container alignItems="center">
              <Grid item xs="auto">
                <Typography variant="body1" noWrap className={cx(classes.textCapitalize, classes.mr1x)}>
                  {_.get(cardInfo, 'subjects[0].chapters[0].concepts[0].conceptId.name', _.get(cardInfo, "contentId", ""))}
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Typography variant="body1" color="textSecondary" noWrap className={cx(classes.textCapitalize, classes.mr1x)}>
                  {getSubjectData()}
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Chip color="primary" variant="outlined"
                  className={classes.contentType}
                  label={getCodeName(cardInfo.contentTypeCode, cardInfo.contentSubTypeCode)}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container alignItems="center" justify="space-between">
              <Grid item xs={7}>
                <div className={classes.subTitle}>
                  <img src={contentTypeIcon[cardInfo.contentTypeCode]} />
                  <span dangerouslySetInnerHTML={{ __html: cardInfo.title.replace(/(<([^>]+)>)/ig, "") }}></span>
                </div>
              </Grid>
              <Grid item xs="auto">
                {getContentStatus()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>

    // </MyPATLink>
  );
}

const mapStateToProps = (state: any) => {
  let ct: any = _.get(state, "mylibraryData.contentType.list", []);
  let ctt: any = {};
  ct.forEach((c: any) => {
    ctt[c.code] = c.name;
  });


  let cst: any = _.get(state, "mylibraryData.contentSubtype.list", []);
  let cstt: any = {};
  cst.forEach((c: any) => {
    cstt[c.code] = c.name;
  });

  return {
    userId: _.get(state, "loginData.userData.authenticatedUser._id", "a"),
    contentType: ctt,
    contentSubtype: cstt,
  }
};

export default connect(mapStateToProps, {})(withStyles(styles)(ContentCard));